import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Response } from '@angular/http';
import { Statique } from "../utils/statique";
import { EbChat } from "../classes/chat";
import { AuthHttp } from "angular2-jwt";

@Injectable()
export class StatiqueService {

	statique: Statique
	constructor(
		private http: Http,
		private authHttp: AuthHttp
	) { }


	getListPays() {
		return this.http.get(Statique.controllerStatiqueListe + "/countries").map((res: Response) => res.json());
	}

	getTypeProcess() {
		return this.http.get(Statique.controllerStatiqueListe + "/typeprocess").map((res: Response) => res.json());
	}

	getTransportRef(term) {
		return this.authHttp.get(Statique.controllerStatiqueListe + "/transportRef?term=" + term).map((res: Response) => res.json());
	}

	getCustomerReferenceAndTransportRef(term) {
		return this.http.get(Statique.controllerStatiqueListe + "/customerRefAndtransportRef?term=" + term).map((res: Response) => res.json());
	}

	getCustomerReference(term) {
		return this.http.get(Statique.controllerStatiqueListe + "/customerReference?term=" + term).map((res: Response) => res.json());
	}

	getListRegions() {
		return this.http.get(Statique.controllerStatiqueListe + "/regions").map((res: Response) => res.json());
	}

	getListTypeDemande() {

		return this.http.get(Statique.controllerStatiqueListe + "/Typedemande").map((res: Response) => res.json());

	}

	getListStatutTransportManagement() {

		return this.http.get(Statique.controllerStatiqueListe + "/listStatutTransportManagement").map((res: Response) => res.json());

	}

	getListStatutTracing() {

		return this.http.get(Statique.controllerStatiqueListe + "/listStatutTracing").map((res: Response) => res.json());

	}

	getListCarrier(term) {
		return this.http.get(Statique.controllerStatiqueListe + "/listCarrier?term=" + term).map((res: Response) => res.json());
	}

	getListCostCenter(term) {
		return this.http.get(Statique.controllerStatiqueListe + "/listCostCenter?term=" + term).map((res: Response) => res.json());
	}

	getListFromSource(apiUrl, compNum?) {
		if(compNum)
		return this.authHttp.get(apiUrl+ "?ebCompagnieNum=" + compNum).map((res: Response) => res.json());

		return this.authHttp.get(apiUrl).map((res: Response) => res.json());
	}
	getTermsFromSource(term, apiUrl, compNum?) {
		if(compNum)
		return this.authHttp.get(apiUrl + "?term=" + term  + "?ebCompagnieNum=" + compNum).map((res: Response) => res.json());

		return this.authHttp.get(apiUrl + "?term=" + term).map((res: Response) => res.json());
	}
	getCurrentDate() {
		return this.http.get(Statique.controllerStatiqueListe + "/getCurrentDate").map((res: Response) => res.json());
	}

	getListEcCurrency() {
		return this.http.get(Statique.controllerStatiqueListe + "/listCurrency").map((res: Response) => res.json());
	}

	getListCategorieDeviation() {
		return this.http.get(Statique.controllerStatiqueListe + "/listCategorieDeviation").map((res: Response) => res.json());
	}

	

	getListContact(term) {
		return this.authHttp.post(Statique.controllerStatiqueListe + "/selectListContact",term).map((res: Response) => res.json());
	}
	
}



// WEBPACK FOOTER //
// ./src/app/services/statique.service.ts